import React from "react";

const Staff_engaging = () => {
  return (
    <>
      <div className>
        <section className="about section">
          <div className="container">
            <div className="">
              <div className="about-content">
                <h3>Staff Attached</h3>
                <table>
                  <tr>
                    <th>Staff Engaged in other Activities </th>
                  </tr>
                  <tr>
                    <td>
                      1. Involvement as PI (Dr. Deepak Rathi) in IRRI JNKVV
                      Joint Project for the Component Lead, Socio-Economic
                      Impact Assessment of the project in (11 District of MP)
                      and Developed questionnair in CAPI by Dr. Hemanr K.
                      Niranjan <br /> 2. Incharge - Head of Department of
                      Agriculture Economics and Farm Management, Field Officer
                      (CCS) & Assigned as a DDO of Institute of Agri-Business
                      Management <br /> 3. Incharge of Credit Seminar : Credit,
                      Synopsys, result seminar and final Thesis via-voce
                      (M.Sc.-20, MBA-20, Ph.D-3) Member of the Minor Department
                      (Extension & Statistics) : Credit, Synopsys, result
                      seminar and final Thesis via-voce of the Students of Ph.D
                      and M.Sc (Ag. Econ.) <br /> 4. Teaching Classe, Midterm,
                      Practical Final exam paper setting, exam duties, paper
                      copy checking & submitted result in academic office as
                      well as evaluation of thesis minimum 3 in a year.
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Staff_engaging;
